import { useEffect, useState } from 'react';

import API from 'js/lib/api';
import user from 'js/lib/user';

import type {
  CreateBoxViewAnnotatorProfileRequest,
  CreateBoxViewAnnotatorProfileResponse,
  FindBoxViewAnnotatorProfileByUserIdRequest,
  FindBoxViewAnnotatorProfileByUserIdResponse,
} from '@coursera/grpc-types-boxintegration/coursera/proto/boxintegration/boxviewannotatorprofiles/v1beta1/box_view_annotator_profiles_api';

const useBoxAnnotatorProfile = (annotationsDisabled: boolean) => {
  const [annotatorProfileId, setAnnotatorProfileId] = useState<string | undefined>();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    const fetchAnnotatorProfile = async () => {
      if (annotationsDisabled) {
        setAnnotatorProfileId(undefined);
        setLoading(false);
        return;
      }

      try {
        setLoading(true);
        setError(null);

        // Attempt to get annotator profile for current user. Create one if it doesn't exist.
        const api = API('/api/grpc/boxintegration/boxviewannotatorprofiles/v1beta1/BoxViewAnnotatorProfilesAPI', {
          type: 'rest',
        });

        const fetchData: FindBoxViewAnnotatorProfileByUserIdRequest = { userId: user.get().id };
        const response: FindBoxViewAnnotatorProfileByUserIdResponse = await api.post(
          'FindBoxViewAnnotatorProfileByUserId',
          { data: fetchData }
        );

        if (response.boxViewAnnotatorProfile.length > 0) {
          // @ts-expect-error TS2532 Unchecked index access, value is possibly undefined see https://www.typescriptlang.org/tsconfig/#noUncheckedIndexedAccess
          setAnnotatorProfileId(response.boxViewAnnotatorProfile[0].boxViewProfileAnnotatorId);
        } else {
          const createData: CreateBoxViewAnnotatorProfileRequest = {
            userId: user.get().id,
            displayName: user.get().display_name,
          };

          const createResponse: CreateBoxViewAnnotatorProfileResponse = await api.post(
            'CreateBoxViewAnnotatorProfile',
            { data: createData }
          );

          setAnnotatorProfileId(createResponse.boxViewAnnotatorProfile?.boxViewProfileAnnotatorId);
        }
      } catch (err) {
        setError(err instanceof Error ? err : new Error('Failed to fetch annotator profile'));
      } finally {
        setLoading(false);
      }
    };

    fetchAnnotatorProfile();
  }, [annotationsDisabled]);

  return {
    annotatorProfileId,
    loading,
    error,
  };
};

export default useBoxAnnotatorProfile;
